import { isTefCard, isTefPix, isTefPixFailed } from '@/store/utils/paybox/paybox-payments'
import { mapGetters } from 'vuex'

const payBoxPayments = {
  computed: {
    ...mapGetters('pages/pdv/payBoxConfiguration', [
      'tefAgentConfigPayload',
      'thermalPrinterAgentConfigPayload',
      'isTefPixCheckStatusEnabled'
    ]),
  },
  methods: {
    async cancelTefPayment(receipt) {
      if (isTefCard(receipt)) {
        const { tefPayment } = receipt
        const { nsuGateway, cardNumber } = tefPayment
        const lastCardDigits = cardNumber?.substring(cardNumber?.length - 4)

        const tefPayload = {
          nsu: nsuGateway,
          originalDate: tefPayment.transactionDateTime,
          amount: receipt.value,
        }

        const formattedValue = this.$options.filters.currency(receipt.value)

        this.showLoadingOverlayV2({
          text: this.$t('PAY_BOX_SALE.TEF.START_TEF_PAYMENT_CANCELATION'),
          title: `${this.$t(
            'Cancelamento TEF'
          )} - (NSU: ${nsuGateway} | Valor: ${formattedValue} | Final cartão: ${lastCardDigits})`,
        })

        await new Promise(resolve => setTimeout(() => resolve(), 5000))

        try {
          let tefPaymentCancelation
          switch (receipt.paymentMethod.method) {
            case this.paymentTypeEnum.CREDIT_CARD:
              tefPaymentCancelation = await window.electronAPI.tef.creditPaymentCancel(
                this.tefAgentConfigPayload,
                tefPayload
              )
              break
            case this.paymentTypeEnum.DEBIT_CARD:
              tefPaymentCancelation = await window.electronAPI.tef.debitPaymentCancel(
                this.tefAgentConfigPayload,
                tefPayload
              )
              break
            default:
              throw new Error(
                `Payment Method: ${receipt.paymentMethod.method} not implemented yet !`
              )
          }

          try {
            await window.electronAPI.print({
              ...this.thermalPrinterAgentConfigPayload,
              request: {
                openCashDrawer: false,
                printTexts: [
                  {
                    printText: tefPaymentCancelation.couponStore,
                    template: 'PAYMENT_GETNET',
                  },
                  {
                    printText: tefPaymentCancelation.couponCustomer,
                    template: 'PAYMENT_GETNET',
                  },
                ],
              },
            })
          } catch (error) {
            console.error('error on print tef', error)
          }

          this.hideLoadingOverlay()
          return tefPaymentCancelation
        } catch (error) {
          if (error.canceled) {
            this.showWarning({
              title: this.$t('Pagamento TEF'),
              message: this.$t(error.displayMessage || 'Operação cancelada no equipamento PINPAD'),
            })
          } else {
            /* eslint-disable no-console */
            console.error('tef-error', error)
            this.showError({ error })
          }
          this.hideLoadingOverlay()
          return null
        }
      }

      return null
    },

    async pixCheckStatus(receipt, saleUuid) {
      if (!isTefPix(receipt)) {
        this.showWarning({ message: this.$t('Consulta não está disponível para este pagamento') })
        return null
      }

      try {
        const { tefPayment } = receipt
        const { transactionCheckStatusCode, transactionIdentifier, paymentServiceProvider } = tefPayment

        const tefPayload = {
          saleId: saleUuid,
          transactionCheckStatusCode,
          transactionIdentifier,
          paymentServiceProvider,
          originalDate: tefPayment.transactionDateTime,
          amount: receipt.value,
        }

        const formattedValue = this.$options.filters.currency(receipt.value)
        this.showLoadingOverlayV2({
          text: this.$t('PAY_BOX_SALE.TEF.START_TEF_PIX_CHECK_STATUS'),
          title: `${this.$t(
            'PIX: Consultando status do pagamento'
          )} - (Valor: ${formattedValue})`,
        })

        const tefPaymentStatus = await window.electronAPI.tef.pixCheckStatus(
          this.tefAgentConfigPayload,
          tefPayload
        )

        this.hideLoadingOverlay()

        return tefPaymentStatus
      } catch (error) {
        if (error.canceled) {
          this.showWarning({
            title: this.$t('Pagamento TEF'),
            message: this.$t(error.displayMessage || 'Operação cancelada no equipamento PINPAD'),
          })
        } else {
          /* eslint-disable no-console */
          console.error('tef-error', error)
          this.showError({ error })
        }

        this.hideLoadingOverlay()
        return null
      }
    },

    mxIsToCheckPixStatus(receipt) {
      return this.isTefPixCheckStatusEnabled && isTefPixFailed(receipt)
    }
  },
}

export default payBoxPayments
